
<template>
  
        <div class="commer-content box-sizing sysMenu">
            <div class="commer-list box-sizing">
                <p class="commer-list-title">
                    系统设置>菜单管理
                </p>
                <div class="commer-list-seacch-box" style="margin-bottom: 40px;">
                    <div class="left-search">
                        
                    </div>
                    <div class="right-add">
                        <el-button type="info" icon="el-icon-plus"  @click='operation(1,0)'>新增根节点</el-button>
                        <el-button type="success" icon="el-icon-plus"  @click='save(menuList)'>保存</el-button>
                    </div>
                </div>
                <div class="treeList">
                        <el-tree
                        :data="menuList"
                        node-key="id"
                        default-expand-all
                        :props="defaultProps"
                        :expand-on-click-node="false">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <div class="tree-sprite">
                                <div>
                                    <span>{{ node.label}} </span>
                                    <i class="el-icon-circle-plus" @click="operation(1,data.id)"></i>
                                    <i class="el-icon-remove"  @click='ifDelete(data.id)'></i>
                                    <i class="el-icon-edit" @click='operation(2,data.id)'></i>
                                </div>
                                <div>
                                    <!-- {{data.sysFuncs[0].id}} -->
                                        <el-checkbox-group v-model="data.sysFuncs">
                                                <el-checkbox v-for="(item,index) in funList" :label="item.id" :key="item.id" :disabled='data.status==0'>{{item.name}}</el-checkbox>
                                        </el-checkbox-group>
                                       <!-- {{ data.sysFuncs[1].id}}{{funList[1].id}} -->
                              
                                    
                                </div>
                            </div>

                        </span>
                      </el-tree>
                </div>
                
            </div>
            <el-dialog
            :title="titleMsg"
            :visible.sync="ifAdd"
            :modal-append-to-body='false'
            width='28%'>
            <el-form :model="addParams" ref="addParams" label-width="100px" class="demo-ruleForm" :rules="rules">
                <!-- <div style="display:flex;margin-bottom:10px;">
                        
                </div> -->
                <el-form-item label="图标名称" prop="iconClass">
                    <el-input v-model="addParams.iconClass"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="addParams.name"></el-input>
                </el-form-item>
                <el-form-item label="前台路径" prop="urlFront">
                    <el-input v-model="addParams.urlFront"></el-input>
                </el-form-item>
                <el-form-item label="后台路径" prop="urlBackground">
                    <el-input v-model="addParams.urlBackground"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="addParams.sort"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="memo">
                    <el-input type="textarea" v-model="addParams.memo"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="addParams.status" placeholder="请选择状态">
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.lable"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ifAdd = false">取 消</el-button>
                <el-button type="primary" @click="addRoot()">保 存</el-button>
            </span>
            </el-dialog>

            <el-dialog
                title="提示"
                :visible.sync="ifDeleteBox"
                :modal-append-to-body='false'
                width="30%">
                <span class="ifDetetes">是否删除</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="ifDeleteBox = false">取 消</el-button>
                    <el-button type="primary" @click="sureDelete">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        
  
</template>
<script>
    import PhotoUpload from  '@/components/public/photoUpload.vue' 
    export default{
        data(){
            return{
                tableData:[{
                    name:'ah '
                }],
                totals:1,
                ifAdd:false,
                titleMsg:'新增',
                rules:{
                    name:[{required: true,message: '请输入名称'}],
                    urlFront:[{required: true,message: '请输入前台路径'}],
                    urlBackground:[{required: true,message: '请输入后台路径'}],
                    sort:[{required: true,message: '请输入序号'}],
                    status:[{required: true,message: '请选择状态'}],
                },
                funList:[],
                menuList:[],
                defaultProps:{
                    children: 'children',
                    label: 'name'
                },
                addParams:{
                    name:'',
                    urlFront:'',
                    urlBackground:'',
                    sort:'',
                    status:'',
                    memo:'',
                    pid:'',
                    iconClass:''
                },
                statusList:[{
                    lable:'正常',
                    value:1
                },{
                    lable:'禁用',
                    value:0
                }],
                ifDeleteBox:false,
                companyID:'',
                tepMenu:[],
             
            }
        },
        methods:{
            //出现新增/编辑框
            operation:function(val,id){
                var vm=this;
                vm.ifAdd=true
         
                if(val==1){
                   vm.addParams={
                        name:'',
                        urlFront:'',
                        urlBackground:'',
                        sort:'',
                        status:'',
                        memo:'',
                        pid:''
                    },
                    vm.titleMsg='新增'
                    vm.addParams.pid=id
                }else{
                    vm.titleMsg='编辑'
                    vm.$http.get('/api/console/sysMenu/query',{
                        params:{
                            id:id
                        }
                    }).then(function(response){
                        let resTemp=response.data
                        for(var i in resTemp){
                            if(i=='createDate'||i=='updateDate'){
                                delete resTemp[i]
                            }
                        }
                        vm.addParams=resTemp
                    })
                }
            },
          
            getDatas:function(){
                var vm=this
                vm.$http.get('/api/console/sysMenu/queryMenu')
                .then(function(response){
                
                    vm.menuList=response.data

                })
            },
            saveCommer:function(menuList){
           
                var vm=this;
                
                menuList.forEach((element,index )=> {
                   if(element.sysFuncs.length>0){
                    
                     element.sysFuncs.forEach((subEle,subIndex)=>{
                        vm.tepMenu.push({mid:element.id,fid:subEle})
                       
                     })
                   }
                   if(element.children){
                      vm.saveCommer(element.children)
                   }
                });
               
            },
            save:function(val){
                var vm=this;
                // console.log(val)
                vm.tepMenu=[]
                vm.saveCommer(val)
                vm.tepMenu=JSON.stringify(vm.tepMenu)
                vm.$http.post('/api/console/sysMenu/saveMenuFunc',
                   {
                       json:vm.tepMenu
                   }
                )
                .then(function(response){
                    if(response.code==0){
                        vm.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        // vm.ifAdd=false;
                        vm.getDatas()
                    }
                })
                
                
            },
            //删除创建时间
            deleteTime:function(val){
                
            },
            //新增根节点保存
            addRoot:function(){
                var vm=this;
                vm.$http.post('/api/console/sysMenu/save',vm.addParams)
                .then(function(response){
                    if(response.code==0){
                        vm.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        vm.ifAdd=false;
                        vm.getDatas()
                    }
                })
            },
            //是否删除数据
			ifDelete:function(companyID){
				this.companyID=companyID
				this.ifDeleteBox=true
			},
            //确认删除
            sureDelete:function(){
                var vm=this;
				vm.$http.post('/api/console/sysMenu/delete',{ids:vm.companyID})
				.then(function(response){
					if(response.code==0){
                        
                        vm.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        vm.ifDeleteBox=false
						vm.getDatas()
					}
						
				})
            },
            //上传图片
			uploadImg:function(val){
				// console.log(val.response.data)
				this.$set(this.addParams,"iconClass",val)
				// console.log(this.addParams.headImage)
				// this.addParams.headImage=val.response.data
			},
        },
        mounted(){
            var vm=this
            vm.$http.get('/api/console/sysFunc/queryPage')
            .then(function(response){
                vm.funList=response.data.items
            })
            vm.getDatas()
        },
        components:{
            PhotoUpload:PhotoUpload
        }
    }
</script>
<style lang="less">
    .sysMenu{
        .el-dialog__footer{
            text-align: center;
            .el-button{
                padding: 9px 20px;
            }
        }
        .custom-tree-node{
            width: 100%;
        }
        .tree-sprite{
            display: flex;
            justify-content: space-between
        }
        .LOGO{
		width: 100px;
		text-align: right;
		line-height: 60px;
		margin-right: 20px;
	    }
        
    }
</style>


// WEBPACK FOOTER //
// src/views/systemSetup/sysMenu.vue